var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsAdjust(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 4.66667C1.3335 4.29848 1.63197 4 2.00016 4H4.66683V5.33333H2.00016C1.63197 5.33333 1.3335 5.03486 1.3335 4.66667Z",
    fill: "#031D42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00016 10.6667C1.63197 10.6667 1.3335 10.9651 1.3335 11.3333C1.3335 11.7015 1.63197 12 2.00016 12H10.0002V10.6667H2.00016Z",
    fill: "#031D42"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3335 10.6667V12H14.0002C14.3684 12 14.6668 11.7015 14.6668 11.3333C14.6668 10.9651 14.3684 10.6667 14.0002 10.6667H11.3335Z",
    fill: "#031D42"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00016 4V5.33333H14.0002C14.3684 5.33333 14.6668 5.03486 14.6668 4.66667C14.6668 4.29848 14.3684 4 14.0002 4H6.00016Z",
    fill: "#031D42"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.3335 4.66675C7.3335 5.77132 6.43807 6.66675 5.3335 6.66675C4.22893 6.66675 3.3335 5.77132 3.3335 4.66675C3.3335 3.56218 4.22893 2.66675 5.3335 2.66675C6.43807 2.66675 7.3335 3.56218 7.3335 4.66675ZM6.00016 4.66675C6.00016 5.03494 5.70169 5.33341 5.3335 5.33341C4.96531 5.33341 4.66683 5.03494 4.66683 4.66675C4.66683 4.29856 4.96531 4.00008 5.3335 4.00008C5.70169 4.00008 6.00016 4.29856 6.00016 4.66675Z",
    fill: "#031D42"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6668 11.3334C12.6668 12.438 11.7714 13.3334 10.6668 13.3334C9.56226 13.3334 8.66683 12.438 8.66683 11.3334C8.66683 10.2288 9.56226 9.33341 10.6668 9.33341C11.7714 9.33341 12.6668 10.2288 12.6668 11.3334ZM11.3335 11.3334C11.3335 11.7016 11.035 12.0001 10.6668 12.0001C10.2986 12.0001 10.0002 11.7016 10.0002 11.3334C10.0002 10.9652 10.2986 10.6667 10.6668 10.6667C11.035 10.6667 11.3335 10.9652 11.3335 11.3334Z",
    fill: "#031D42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsAdjust);
export default __webpack_public_path__ + "static/media/settings-adjust.7dcb075a.svg";
export { ForwardRef as ReactComponent };